module.exports = __webpack_public_path__ + "img/navbar-2.b12c397a.svg";